import { gql } from "@apollo/client";

export const GET_PERSONAL_SETTINGS = gql`
  query GetPersonalSettings($skipApiKeysManagedByNonRootAdminsField: Boolean = false) {
    authorizationScheme
    apiKeysManagedByNonRootAdmins @skip(if: $skipApiKeysManagedByNonRootAdminsField)
  }
`;
